export const isVideo = (url: string) => {
  return url.toLowerCase().endsWith("mkv") || url.toLowerCase().endsWith("mp4");
};
